import { DisabledTag, Icon } from '@nile/components';
import { Avatar, Tooltip } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const DetailHolderTag = styled.div`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: flex-start;
  max-width: 20%;
  .titleHolder {
    color: #00000099;
    font-size: 1.4rem;
    // font-weight: 500;
  }
  .content {
    /* margin-top: 1rem; */
    align-items: center;
    width: calc(100% - 10px);
    span {
      &:last-child {
        width: inherit;
      }
    }
    .value {
      width: 90%;
      color: #000000cc;
      font-size: 1.4rem;
      font-weight: 700;
      &.value-na {
        font-weight: 400;
      }
    }
  }
`;

const DetailHolder = ({ title, value, avatar, icon }) => {
  return (
    <DetailHolderTag>
      {/* <div className="titleHolder">{title}</div> */}
      <div className="fx content">
        <Tooltip content={<div>{title}</div>}>
          {avatar ? (
            <Avatar name={value} size="small" customer />
          ) : (
            <div className="opacity5">
              <SVGIcon name={icon} />
            </div>
          )}
        </Tooltip>
        {value === 'NA' ? (
          <DisabledTag className="ml-10">
            <FormattedMessage id="project.details.card.NA" />
          </DisabledTag>
        ) : (
          <Tooltip content={<div>{value}</div>}>
            <div className="value ml-10 ellipsis">{value}</div>
          </Tooltip>
        )}
      </div>
    </DetailHolderTag>
  );
};

export default DetailHolder;
